import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { Sky } from 'three/examples/jsm/Addons.js'
import { Timer } from 'three/addons/misc/Timer.js'
import GUI from 'lil-gui'
import Stats from 'three/examples/jsm/libs/stats.module.js'
import gsap from 'gsap'
/**
 * Base
 */
// Debug
const gui = new GUI()

// Stats
const stats = new Stats()
document.body.appendChild(stats.dom)

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

// textures

const textureLoader = new THREE.TextureLoader()

// floor texture
const floorAlphaTexture = textureLoader.load('./floor/alpha.jpg')
const floorColorTexture = textureLoader.load('./floor/coast_sand_rocks_02_1k/coast_sand_rocks_02_diff_1k.webp')
const floorArmTexture = textureLoader.load('./floor/coast_sand_rocks_02_1k/coast_sand_rocks_02_arm_1k.webp')
const floorNormalTexture = textureLoader.load('./floor/coast_sand_rocks_02_1k/coast_sand_rocks_02_nor_gl_1k.webp')
const floorDisplacementTexture = textureLoader.load('./floor/coast_sand_rocks_02_1k/coast_sand_rocks_02_disp_1k.webp')

floorColorTexture.repeat.set(8, 8)
floorColorTexture.colorSpace = THREE.SRGBColorSpace

floorArmTexture.repeat.set(8, 8)
floorNormalTexture.repeat.set(8, 8)
floorDisplacementTexture.repeat.set(8, 8)

floorColorTexture.wrapS = THREE.RepeatWrapping
floorColorTexture.wrapT = THREE.RepeatWrapping

floorArmTexture.wrapS = THREE.RepeatWrapping
floorArmTexture.wrapT = THREE.RepeatWrapping

floorNormalTexture.wrapS = THREE.RepeatWrapping
floorNormalTexture.wrapT = THREE.RepeatWrapping

floorDisplacementTexture.wrapS = THREE.RepeatWrapping
floorDisplacementTexture.wrapT = THREE.RepeatWrapping

// wall texture
const wallColorTexture = textureLoader.load('./wall/castle_brick_broken_06_1k/castle_brick_broken_06_diff_1k.webp')
const wallArmTexture = textureLoader.load('./wall/castle_brick_broken_06_1k/castle_brick_broken_06_arm_1k.webp')
const wallNormalTexture = textureLoader.load('./wall/castle_brick_broken_06_1k/castle_brick_broken_06_nor_gl_1k.webp')

wallColorTexture.colorSpace = THREE.SRGBColorSpace

// roof texture
const roofColorTexture = textureLoader.load('./roof/roof_slates_02_1k/roof_slates_02_diff_1k.webp')
const roofArmTexture = textureLoader.load('./roof/roof_slates_02_1k/roof_slates_02_arm_1k.webp')
const roofNormalTexture = textureLoader.load('./roof/roof_slates_02_1k/roof_slates_02_nor_gl_1k.webp')

roofColorTexture.colorSpace = THREE.SRGBColorSpace


roofColorTexture.repeat.set(3, 1)
roofArmTexture.repeat.set(3, 1) 
roofNormalTexture.repeat.set(3, 1) 

roofColorTexture.wrapS = THREE.RepeatWrapping
roofArmTexture.wrapS = THREE.RepeatWrapping 
roofNormalTexture.wrapS = THREE.RepeatWrapping 

// bush texture
const bushColorTexture = textureLoader.load('./bush/leaves_forest_ground_1k/leaves_forest_ground_diff_1k.webp')
const bushArmTexture = textureLoader.load('./bush/leaves_forest_ground_1k/leaves_forest_ground_nor_gl_1k.webp')
const bushNormalTexture = textureLoader.load('./bush/leaves_forest_ground_1k/leaves_forest_ground_nor_gl_1k.webp')

bushColorTexture.colorSpace = THREE.SRGBColorSpace

bushColorTexture.repeat.set(3, 1)
bushArmTexture.repeat.set(3, 1) 
bushNormalTexture.repeat.set(3, 1) 

bushColorTexture.wrapS = THREE.RepeatWrapping
bushArmTexture.wrapS = THREE.RepeatWrapping 
bushNormalTexture.wrapS = THREE.RepeatWrapping 

// grave texture
const graveColorTexture = textureLoader.load('./grave/plastered_stone_wall_1k/plastered_stone_wall_diff_1k.webp')
const graveArmTexture = textureLoader.load('./grave/plastered_stone_wall_1k/plastered_stone_wall_arm_1k.webp')
const graveNormalTexture = textureLoader.load('./grave/plastered_stone_wall_1k/plastered_stone_wall_nor_gl_1k.webp')

graveColorTexture.colorSpace = THREE.SRGBColorSpace

graveColorTexture.repeat.set(0.3, 0.4)
graveArmTexture.repeat.set(0.3, 0.4) 
graveNormalTexture.repeat.set(0.3, 0.4) 

// door texture
const doorColorTexture = textureLoader.load('./door/color.webp')
const doorAlphaTexture = textureLoader.load('./door/alpha.webp')
const doorAmbientOcclusionTexture = textureLoader.load('./door/ambientOcclusion.webp')
const doorHeightTexture = textureLoader.load('./door/height.webp')
const doorNormalTexture = textureLoader.load('./door/normal.webp')
const doorMetalnessTexture = textureLoader.load('./door/metalness.webp')
const doorRoughnessTexture = textureLoader.load('./door/roughness.webp')

doorColorTexture.colorSpace = THREE.SRGBColorSpace


/**
 * House
 */

// floor
const floor = new THREE.Mesh(
    new THREE.PlaneGeometry(20, 20, 100, 100),
    new THREE.MeshStandardMaterial(
        {
            alphaMap: floorAlphaTexture,
            transparent: true,
            map: floorColorTexture,
            aoMap: floorArmTexture,
            roughnessMap: floorArmTexture,
            metalnessMap: floorArmTexture,
            normalMap: floorNormalTexture,
            displacementMap: floorDisplacementTexture,
            displacementScale: 0.3,
            displacementBias: - 0.2
        }
    )
)
floor.rotation.x = -(Math.PI / 2)
scene.add(floor)


gui.add(floor.material, 'displacementScale').min(0).max(1).step(0.01).name('floorDisplacementScale')
gui.add(floor.material, 'displacementBias').min(-1).max(1).step(0.01).name('floorDisplacementBias')



// group
const house = new THREE.Group() 
scene.add(house)

// walls
const walls = new THREE.Mesh(
    new THREE.BoxGeometry(4, 2.5, 4),
    new THREE.MeshStandardMaterial(
        {
            map: wallColorTexture,
            aoMap: wallArmTexture,
            roughnessMap: wallArmTexture,
            metalnessMap: wallArmTexture,
            normalMap: wallNormalTexture
        }
    )
)
walls.position.y += 1.25 
house.add(walls)

// roof
const roof = new THREE.Mesh(
    new THREE.ConeGeometry(3.5, 1.5, 4),
    new THREE.MeshStandardMaterial({
        map: roofColorTexture,
        aoMap: roofArmTexture,
        roughnessMap: roofArmTexture,
        metalnessMap: roofArmTexture,
        normalMap: roofNormalTexture
    })
)
roof.position.y = 2.5 + .75
roof.rotation.y = Math.PI / 4
house.add(roof)

// door
const doorGeometry = new THREE.PlaneGeometry(2.2, 2.2, 50, 50)

const door = new THREE.Mesh(
    doorGeometry, 
    new THREE.MeshStandardMaterial({
        map: doorColorTexture,
        transparent: true,
        alphaMap: doorAlphaTexture,
        aoMap: doorAmbientOcclusionTexture,
        displacementMap: doorHeightTexture,
        normalMap: doorNormalTexture,
        metalnessMap: doorMetalnessTexture,
        roughnessMap: doorRoughnessTexture,
        displacementScale: 0.15,
        displacementBias: -0.04
    }

    )
)
door.position.y = 1
door.position.z = 2 + 0.01

door.material.side = THREE.DoubleSide
house.add(door)

// behind door
const behindDoor = new THREE.Mesh(
    new THREE.PlaneGeometry(2.2, 2.2, 50, 50),
    new THREE.MeshStandardMaterial({
        color:'black',
        transparent: true,
        alphaMap: doorAlphaTexture,
    }

    )
)
behindDoor.position.y = 1
behindDoor.position.z = 2 + 0.009
house.add(behindDoor)

// bushes
const bushGeometry = new THREE.SphereGeometry(1, 16, 16)
const bushMaterial = new THREE.MeshStandardMaterial({
    color: '#ccffcc',
    map: bushColorTexture,
    aoMap: bushArmTexture,
    roughnessMap: bushArmTexture,
    metalnessMap: bushArmTexture,
    normalMap: bushNormalTexture
})

const bush1 = new THREE.Mesh(
    bushGeometry, bushMaterial
)
bush1.scale.set(0.5, 0.5, 0.5)
bush1.position.set(0.8 + 0.3, 0.2, 2.2)
bush1.rotation.x = -0.75

const bush2 = new THREE.Mesh(
    bushGeometry, bushMaterial
)
bush2.scale.set(0.25, 0.25, 0.25)
bush2.position.set(1.4 + 0.3, 0.1, 2.1)
bush2.rotation.x = -0.75

const bush3 = new THREE.Mesh(
    bushGeometry, bushMaterial
)
bush3.scale.set(0.4, 0.4, 0.4)
bush3.position.set(-0.8 -0.65, 0.1, 2.2)
bush3.rotation.x = -0.75

const bush4 = new THREE.Mesh(
    bushGeometry, bushMaterial
)
bush4.scale.set(0.15, 0.15, 0.15)
bush4.position.set(-1, 0.05, 2.6)
bush4.rotation.x = -0.75
house.add(bush1, bush2, bush3, bush4)

// graves
const graveGeometry = new THREE.BoxGeometry(0.6, 0.8, 0.2)
const graveMaterial = new THREE.MeshStandardMaterial({
    map: graveColorTexture,
    aoMap: graveArmTexture,
    roughnessMap: graveArmTexture,
    metalnessMap: graveArmTexture,
    normalMap: graveNormalTexture
})

const graves = new THREE.Group()
scene.add(graves)

for (let i = 0; i < 30; i++){

    const angle = Math.random() * Math.PI * 2
    const radius = 4 + Math.random() * 4
    const x = Math.sin(angle) * radius
    const z = Math.cos(angle) * radius

    // mesh
    const grave = new THREE.Mesh(graveGeometry, graveMaterial)
    grave.position.x = x
    grave.position.z = z
    grave.position.y = Math.random() * 0.4
    grave.rotation.x = (Math.random() - 0.5) * 0.4
    grave.rotation.y = (Math.random() - 0.5) * 0.4
    grave.rotation.z = (Math.random() - 0.5) * 0.4

    // add to graves group
    graves.add(grave)
}


/**
 * Lights
 */
// Ambient light
const ambientLight = new THREE.AmbientLight('#86cdff', 0.275)
scene.add(ambientLight)

// Directional light
const directionalLight = new THREE.DirectionalLight('#86cdff', 1)
directionalLight.position.set(3, 2, -8)
scene.add(directionalLight)

// door light
const doorLight = new THREE.PointLight('#ff7d48', 5)
doorLight.position.set(0, 2.2, 2.5)
house.add(doorLight)

// ghosts
const ghost1 = new THREE.PointLight('#8800ff', 6)
const ghost2 = new THREE.PointLight('#ff0088', 6)
const ghost3 = new THREE.PointLight('#ff0000', 6)

scene.add(ghost1, ghost2, ghost3)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 4
camera.position.y = 2
camera.position.z = 5
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.minDistance = 1.5
controls.maxDistance = 30

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))


// shadows
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFShadowMap

// cast and recieve
directionalLight.castShadow = true
ghost1.castShadow = true
ghost2.castShadow = true
ghost3.castShadow = true

walls.castShadow = true
walls.castShadow = true
roof.castShadow = true
floor.receiveShadow = true

bush1.castShadow = true
bush2.castShadow = true
bush3.castShadow = true
bush4.castShadow = true

for(const grave of graves.children)
{
    grave.castShadow = true
    grave.receiveShadow = true
}

// sky
const sky = new Sky()
sky.material.uniforms['turbidity'].value = 10
sky.material.uniforms['rayleigh'].value = 3
sky.material.uniforms['mieCoefficient'].value = 0.1
sky.material.uniforms['mieDirectionalG'].value = 0.95
sky.material.uniforms['sunPosition'].value.set(0.3, -0.038, -0.95)
sky.scale.setScalar(100)
scene.add(sky)

// fog
// scene.fog = new THREE.Fog('#04343f', 10, 13)
scene.fog = new THREE.FogExp2('#04343f', 0.1)

// shadow mapping
directionalLight.shadow.mapSize.setScalar(256)
directionalLight.shadow.camera.top = 8
directionalLight.shadow.camera.right = 8
directionalLight.shadow.camera.left = - 8
directionalLight.shadow.camera.bottom = - 8
directionalLight.shadow.camera.near = 1
directionalLight.shadow.camera.far = 20

ghost1.shadow.mapSize.setScalar(256)
ghost1.shadow.camera.far = 10

ghost2.shadow.mapSize.setScalar(256)
ghost2.shadow.camera.far = 10

ghost3.shadow.mapSize.setScalar(256)
ghost3.shadow.camera.far = 10



function flickerDoorLight() {
    
    let tl = gsap.timeline(
        {
            repeat: 2, 
            repeatDelay: 0.01,
            onComplete: () => {
                doorLight.intensity = 5
            }
        }
    );

    for (let i = 0; i < 10; i++){
        let intensity = Math.random() * 5
        tl.to(doorLight, {intensity: intensity, duration: 0.05});
    }
    
}

function createBat() {
    // First keep your existing bat geometry setup code
    const batGroup = new THREE.Group()
    const leftWingGeometry = new THREE.ConeGeometry( 1, 1, 3, 1, 0, 0, 2 ); 
    const material = new THREE.MeshBasicMaterial( {color: 'black', side: THREE.DoubleSide, wireframe: false} );
    const rightleftWingGeometry = leftWingGeometry.clone()
    const leftBatWing = new THREE.Mesh(leftWingGeometry, material)
    const rightBatWing = new THREE.Mesh(rightleftWingGeometry, material)
    const cylinderGeometry = new THREE.CapsuleGeometry(1, 3, 5, 10)
    const body = new THREE.Mesh(cylinderGeometry, material)
    scene.add(batGroup)

    body.position.z = 5
    body.position.y = 1.93
    body.position.x = -0.05
    body.rotation.x = Math.PI / 2

    leftBatWing.position.z = 5
    leftBatWing.position.y = 2
    leftBatWing.position.x = -0.1
    leftBatWing.rotation.y = -Math.PI
    leftBatWing.rotation.x = -Math.PI / 8
    leftBatWing.rotation.z = -Math.PI /2

    rightBatWing.position.z = 5
    rightBatWing.position.y = 2
    rightBatWing.rotation.x = Math.PI / 4
    rightBatWing.rotation.z = -Math.PI / 2

    leftBatWing.scale.set(0.1, 0.1, 0.1)
    rightBatWing.scale.set(0.1, 0.1, 0.1)
    body.scale.set(0.03, 0.03, 0.03)
    batGroup.add(leftBatWing, rightBatWing, body)
    return batGroup
}
const bats = new THREE.Group
scene.add(bats)
function spawnBat() {
    for(let i = 0; i < 10; i++) {
        const bat = createBat()
        // Randomize initial position
        bat.position.set(
            0, 
            Math.random() - 2, // y between -2 and -1
            -4// start at z=-4 
            
        )
    bats.add(bat)
}
}



function animateBat(){
    // Animate each bat
    
    for (let batGroup of bats.children){
        gsap.to(batGroup.position, {
            z: 20,
            x: Math.random() * 10 - 5,
            y: Math.random() * 4 + 1,
            duration: 20,
            ease: "power1.out",
            onStart: () => {
                playSound()
            },
            onComplete: () => {
                // Clear the bats group 
                while(bats.children.length > 0) {
                    const bat = bats.children[0];
                    if(bat.geometry) bat.geometry.dispose();
                    if(bat.material) bat.material.dispose();
                    bats.remove(bat);
                }
            }
        });
        // to animate left wing flap
        gsap.to(batGroup.children[0].rotation, {
            z: -Math.PI / 32,
            duration: 0.2,
            repeat: -1,
            yoyo: true,
            ease: "none"
        });
        // to animate right wing flap
        gsap.to(batGroup.children[1].rotation, {
            z: Math.PI / 32,
            duration: 0.2, 
            repeat: -1,
            yoyo: true,
            ease: "none"
        });
    }
}


let currentAnimation = null
function toggleDoor() {
    // Kill any existing animation
    if(currentAnimation) {
        currentAnimation.kill();
    }
    if(door.rotation.y === 0){
        door.rotation.y = - Math.PI * 0.5
        door.position.x = - 0.55
        door.position.z = 2.5
        spawnBat()
        animateBat()
    }
    else{
        door.rotation.y = 0
        door.position.x = 0
        door.position.z = 2.01
    }
}



// setInterval(spawnBat, 1000)

window.addEventListener('click', (event) => {
    console.log('user clicked');
    const x = (event.clientX / sizes.width) * 2 - 1
    const y = -(event.clientY / sizes.height) * 2 + 1
    console.log(x, y);
    if(x > - 0.5 && x < 0.5 && y < 0.5 && y > 0){
        flickerDoorLight()
        toggleDoor()
    }

});

/**
 * Animate
 */
const timer = new Timer()

const tick = () =>
{   
    stats.begin()
    // monitored code goes here
    
    // Timer
    timer.update()
    const elapsedTime = timer.getElapsed()
    // toggleDoor()
    // update ghosts
    const ghost1Angle = elapsedTime * 0.5
    ghost1.position.x = Math.cos(ghost1Angle) * 4
    ghost1.position.z = Math.sin(ghost1Angle) * 4
    ghost1.position.y = Math.sin(ghost1Angle) * Math.sin(ghost1Angle * 2.34) * Math.sin(ghost1Angle * 3.45)

    const ghost2Angle = - elapsedTime * 0.38
    ghost2.position.x = Math.cos(ghost2Angle) * 5
    ghost2.position.z = Math.sin(ghost2Angle) * 5
    ghost2.position.y = Math.sin(ghost2Angle) * Math.sin(ghost2Angle * 2.34) * Math.sin(ghost2Angle * 3.45)

    const ghost3Angle = elapsedTime * 0.23
    ghost3.position.x = Math.cos(ghost3Angle) * 6
    ghost3.position.z = Math.sin(ghost3Angle) * 6

    // Reset controls when it goes out of view
    controls.maxPolarAngle = Math.PI / 2.1
    controls.minDistance = 3
    controls.maxDistance = 30

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)
    stats.end()
    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()

